export const qldQuotesData = [
  {
    "name": "Alexandra hillls",
    "value": 2,
    "lat": -27.5253755,
    "lng": 153.2116516
  },
  {
    "name": "Amberley",
    "value": 3,
    "lat": -27.62778345,
    "lng": 152.69545110840596
  },
  {
    "name": "Annerley",
    "value": 1,
    "lat": -27.5096348,
    "lng": 153.0327018
  },
  {
    "name": "Archerfield",
    "value": 1,
    "lat": -27.569485999999998,
    "lng": 153.00872543991687
  },
  {
    "name": "Arundel",
    "value": 1,
    "lat": -27.9360655,
    "lng": 153.3653514
  },
  {
    "name": "Ascot",
    "value": 1,
    "lat": -27.429703,
    "lng": 153.0638907278646
  },
  {
    "name": "Ashmore",
    "value": 1,
    "lat": -27.9909266,
    "lng": 153.3770522
  },
  {
    "name": "Aspley",
    "value": 1,
    "lat": -27.3628522,
    "lng": 153.0164177
  },
  {
    "name": "Beaudesert",
    "value": 3,
    "lat": -27.9885617,
    "lng": 152.9961186
  },
  {
    "name": "Bellbowrie",
    "value": 1,
    "lat": -27.55812,
    "lng": 152.8862651
  },
  {
    "name": "Birnam",
    "value": 1,
    "lat": -27.4932795,
    "lng": 151.92426189405035
  },
  {
    "name": "Booval",
    "value": 1,
    "lat": -27.5971279,
    "lng": 152.7928802
  },
  {
    "name": "Brendale",
    "value": 3,
    "lat": -27.3173155,
    "lng": 152.9811617
  },
  {
    "name": "Brisbane",
    "value": 10,
    "lat": -27.4689623,
    "lng": 153.0235009
  },
  {
    "name": "Brisbane Airport",
    "value": 8,
    "lat": -27.387621250000002,
    "lng": 153.12158203524928
  },
  {
    "name": "Brisbane City",
    "value": 3,
    "lat": -27.468973849999998,
    "lng": 153.02348848660907
  },
  {
    "name": "Broadbeach",
    "value": 1,
    "lat": -28.0281465,
    "lng": 153.4312768805923
  },
  {
    "name": "Bundall",
    "value": 2,
    "lat": -28.0112822,
    "lng": 153.4080912
  },
  {
    "name": "Caboolture",
    "value": 3,
    "lat": -27.0839336,
    "lng": 152.9510863
  },
  {
    "name": "Caloundra",
    "value": 2,
    "lat": -26.7981633,
    "lng": 153.1354434
  },
  {
    "name": "Carindale",
    "value": 1,
    "lat": -27.5032764,
    "lng": 153.1040678
  },
  {
    "name": "Chambers Flat",
    "value": 1,
    "lat": -27.748186,
    "lng": 153.0792864
  },
  {
    "name": "Collingwood Park",
    "value": 2,
    "lat": -27.6245511,
    "lng": 152.8563239
  },
  {
    "name": "Coolangatta",
    "value": 1,
    "lat": -28.1703323,
    "lng": 153.53046372502652
  },
  {
    "name": "Coolum Beach",
    "value": 1,
    "lat": -26.53284,
    "lng": 153.0697205622449
  },
  {
    "name": "Coomera",
    "value": 4,
    "lat": -27.9930182,
    "lng": 153.2234163
  },
  {
    "name": "Cooroy",
    "value": 3,
    "lat": -26.4176809,
    "lng": 152.9111931
  },
  {
    "name": "Corbould Park",
    "value": 3,
    "lat": -26.7974815,
    "lng": 153.06028936585696
  },
  {
    "name": "Cunnamulla",
    "value": 1,
    "lat": -28.035251799999998,
    "lng": 145.6246587724179
  },
  {
    "name": "Currumbin",
    "value": 1,
    "lat": -28.1369655,
    "lng": 153.4799277
  },
  {
    "name": "Ellen Grove",
    "value": 1,
    "lat": -27.6184661,
    "lng": 152.9488045
  },
  {
    "name": "Flaxton",
    "value": 1,
    "lat": -26.6573646,
    "lng": 152.8781989
  },
  {
    "name": "Gatton",
    "value": 1,
    "lat": -27.5615314,
    "lng": 152.2791353
  },
  {
    "name": "Gaythorne",
    "value": 4,
    "lat": -27.4192267,
    "lng": 152.9849743
  },
  {
    "name": "Glamorgan Vale",
    "value": 1,
    "lat": -27.510865,
    "lng": 152.6192823
  },
  {
    "name": "Gold Coast",
    "value": 1,
    "lat": -28.0023731,
    "lng": 153.4145987
  },
  {
    "name": "Greenbank",
    "value": 1,
    "lat": -27.7317798,
    "lng": 152.9837006
  },
  {
    "name": "Gympie",
    "value": 2,
    "lat": -26.1900447,
    "lng": 152.6600256
  },
  {
    "name": "Hamilton",
    "value": 1,
    "lat": -20.358136950000002,
    "lng": 148.9521301512771
  },
  {
    "name": "Helensvale",
    "value": 1,
    "lat": -27.9254255,
    "lng": 153.3389897
  },
  {
    "name": "Hemmant",
    "value": 1,
    "lat": -27.4505703,
    "lng": 153.1305205
  },
  {
    "name": "Hendra",
    "value": 1,
    "lat": -27.4175215,
    "lng": 153.07054479854912
  },
  {
    "name": "Hope Island",
    "value": 1,
    "lat": -27.8651137,
    "lng": 153.357731
  },
  {
    "name": "Indooroopilly",
    "value": 1,
    "lat": -27.5065612,
    "lng": 152.98227768597326
  },
  {
    "name": "Ipswich",
    "value": 3,
    "lat": -27.6160323,
    "lng": 152.7608348
  },
  {
    "name": "Jimboomba",
    "value": 1,
    "lat": -27.8318573,
    "lng": 153.0227538
  },
  {
    "name": "Kelvin Grove",
    "value": 1,
    "lat": -27.450162,
    "lng": 153.01266953209569
  },
  {
    "name": "Kenmore",
    "value": 1,
    "lat": -27.515645,
    "lng": 152.9376610056806
  },
  {
    "name": "Kippa-Ring",
    "value": 2,
    "lat": -27.2251585,
    "lng": 153.083318
  },
  {
    "name": "Labrador",
    "value": 1,
    "lat": -27.9427642,
    "lng": 153.3987125
  },
  {
    "name": "Laidley",
    "value": 1,
    "lat": -27.6395345,
    "lng": 152.41328938320356
  },
  {
    "name": "Lake Macdonald",
    "value": 1,
    "lat": -26.389505999999997,
    "lng": 152.93648954032258
  },
  {
    "name": "Logan",
    "value": 1,
    "lat": -27.6424132,
    "lng": 153.1131037
  },
  {
    "name": "Logan Central",
    "value": 1,
    "lat": -27.6412988,
    "lng": 153.1072741
  },
  {
    "name": "Loganlea",
    "value": 1,
    "lat": -27.6731622,
    "lng": 153.137161
  },
  {
    "name": "Lota",
    "value": 2,
    "lat": -27.4679039,
    "lng": 153.1883924
  },
  {
    "name": "Lytton",
    "value": 3,
    "lat": -27.4145833,
    "lng": 153.15063881978966
  },
  {
    "name": "Main Beach",
    "value": 6,
    "lat": -27.9787768,
    "lng": 153.4271228
  },
  {
    "name": "Manly",
    "value": 3,
    "lat": -27.453347,
    "lng": 153.1840865329279
  },
  {
    "name": "Mansfield",
    "value": 3,
    "lat": -27.5314948,
    "lng": 153.1015318
  },
  {
    "name": "Mapleton",
    "value": 1,
    "lat": -26.6241397,
    "lng": 152.866157
  },
  {
    "name": "Marcoola",
    "value": 4,
    "lat": -26.5922485,
    "lng": 153.07979856090444
  },
  {
    "name": "Maroochydore",
    "value": 1,
    "lat": -26.6556523,
    "lng": 153.0946684
  },
  {
    "name": "Meadowbrook",
    "value": 1,
    "lat": -27.6624666,
    "lng": 153.1415558
  },
  {
    "name": "Mt Gravatt",
    "value": 1,
    "lat": -27.56272235,
    "lng": 153.08212459593827
  },
  {
    "name": "Murarrie",
    "value": 2,
    "lat": -27.44912,
    "lng": 153.1060533761757
  },
  {
    "name": "Narangba",
    "value": 2,
    "lat": -27.2027145,
    "lng": 152.9592212
  },
  {
    "name": "Nerang",
    "value": 2,
    "lat": -27.9896566,
    "lng": 153.3365942
  },
  {
    "name": "Newstead",
    "value": 1,
    "lat": -27.4483345,
    "lng": 153.0461534314082
  },
  {
    "name": "Newtown",
    "value": 1,
    "lat": -27.5553505,
    "lng": 151.93041110229922
  },
  {
    "name": "Noosa Heads",
    "value": 1,
    "lat": -26.40014,
    "lng": 153.0910490046545
  },
  {
    "name": "Ormeau Hills",
    "value": 1,
    "lat": -27.800612,
    "lng": 153.23374626627793
  },
  {
    "name": "Oxenford",
    "value": 1,
    "lat": -27.9015337,
    "lng": 153.2997577
  },
  {
    "name": "Palm Beach",
    "value": 1,
    "lat": -28.1155325,
    "lng": 153.45839363242405
  },
  {
    "name": "Palmwoods",
    "value": 7,
    "lat": -26.692799,
    "lng": 152.96086073528522
  },
  {
    "name": "Parkinson",
    "value": 2,
    "lat": -27.6357372,
    "lng": 153.0300028
  },
  {
    "name": "Port of Brisbane",
    "value": 1,
    "lat": -27.3823606,
    "lng": 153.1693616
  },
  {
    "name": "Redbank Plains",
    "value": 2,
    "lat": -27.6513182,
    "lng": 152.8479458
  },
  {
    "name": "Redcliffe",
    "value": 2,
    "lat": -27.2268785,
    "lng": 153.1129973
  },
  {
    "name": "Redland Bay",
    "value": 1,
    "lat": -27.6126945,
    "lng": 153.3036238
  },
  {
    "name": "Ripley",
    "value": 2,
    "lat": -27.6712978,
    "lng": 152.7804522
  },
  {
    "name": "Rochedale",
    "value": 1,
    "lat": -27.6009655,
    "lng": 153.1283725
  },
  {
    "name": "Rocklea",
    "value": 1,
    "lat": -27.5482033,
    "lng": 153.0115871
  },
  {
    "name": "Runaway Bay",
    "value": 1,
    "lat": -27.9122419,
    "lng": 153.4029513
  },
  {
    "name": "Salisbury",
    "value": 1,
    "lat": -27.5543181,
    "lng": 153.0265175
  },
  {
    "name": "Scarborough",
    "value": 1,
    "lat": -27.2062945,
    "lng": 153.1139465
  },
  {
    "name": "Somerset Dam",
    "value": 1,
    "lat": -27.3956703,
    "lng": 152.61213600821043
  },
  {
    "name": "South Brisbane",
    "value": 1,
    "lat": -27.47564805,
    "lng": 153.0203484303831
  },
  {
    "name": "South Ripley",
    "value": 2,
    "lat": -27.7170573,
    "lng": 152.8251117
  },
  {
    "name": "Southport",
    "value": 4,
    "lat": -27.9687807,
    "lng": 153.4066696
  },
  {
    "name": "Springfield Central",
    "value": 1,
    "lat": -27.6861177,
    "lng": 152.9037832
  },
  {
    "name": "Springfield Lakes",
    "value": 1,
    "lat": -27.6826685,
    "lng": 152.92026982983856
  },
  {
    "name": "Stapylton",
    "value": 1,
    "lat": -27.73143105,
    "lng": 153.24603398535044
  },
  {
    "name": "Sumner",
    "value": 1,
    "lat": -27.5658793,
    "lng": 152.9338149
  },
  {
    "name": "Sunshine Beach",
    "value": 3,
    "lat": -26.8156844,
    "lng": 153.1197588
  },
  {
    "name": "Surfers Paradise",
    "value": 1,
    "lat": -27.9989899,
    "lng": 153.42398
  },
  {
    "name": "Swanbank",
    "value": 1,
    "lat": -27.6612741,
    "lng": 152.8241225
  },
  {
    "name": "Tannum Sands",
    "value": 1,
    "lat": -23.9911035,
    "lng": 151.3808714828221
  },
  {
    "name": "Tarome",
    "value": 1,
    "lat": -28.0062265,
    "lng": 152.44343973084344
  },
  {
    "name": "Tewantin",
    "value": 1,
    "lat": -26.3920057,
    "lng": 153.0391832
  },
  {
    "name": "Toowong",
    "value": 9,
    "lat": -27.478974,
    "lng": 152.98532411078423
  },
  {
    "name": "Upper Coomera",
    "value": 2,
    "lat": -27.8529809,
    "lng": 153.2982761
  },
  {
    "name": "Victoria Point",
    "value": 1,
    "lat": -27.5843003,
    "lng": 153.300364
  },
  {
    "name": "Wacol",
    "value": 1,
    "lat": -27.589173,
    "lng": 152.9243501
  },
  {
    "name": "Walloon",
    "value": 7,
    "lat": -27.6073451,
    "lng": 152.6679831
  },
  {
    "name": "Wellington Point",
    "value": 1,
    "lat": -27.494379,
    "lng": 153.2417439
  },
  {
    "name": "Willawong",
    "value": 1,
    "lat": -27.5980978,
    "lng": 153.005894
  },
  {
    "name": "Windsor",
    "value": 1,
    "lat": -27.4346805,
    "lng": 153.0309963977168
  },
  {
    "name": "Wishart",
    "value": 1,
    "lat": -27.5514355,
    "lng": 153.1031592
  },
  {
    "name": "Woody Point",
    "value": 1,
    "lat": -27.2585089,
    "lng": 153.103077
  },
  {
    "name": "Wynnum",
    "value": 1,
    "lat": -27.437718699999998,
    "lng": 153.16597426908976
  },
  {
    "name": "Yarrabilba",
    "value": 4,
    "lat": -27.8030098,
    "lng": 153.1081584
  },
  {
    "name": "Yatala",
    "value": 1,
    "lat": -27.7352654,
    "lng": 153.2252177
  },
  {
    "name": "brisbane CBD",
    "value": 1,
    "lat": -27.466829,
    "lng": 153.0273743
  }
];
